import HeaderMenu from 'components/Header/HeaderMenu';
import { SITE } from 'config/config';
import { useEffect, useState } from 'react';
import { getAllSetting } from 'service/base';
import { SETTING_KEYS } from 'utils/common/const';

const RuleFixPage = () => {
  const [dataSettings, setDataSettings] = useState([]);

  useEffect(() => {
    fetchAllSetting();
  }, []);

  const fetchAllSetting = async () => {
    try {
      const res = await getAllSetting({ site: SITE });
      setDataSettings(res?.data || []);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  console.log('dataSettings', dataSettings);

  return (
    <div className="w-full min-h-full">
      <div className="relative z-10 pb-5">
        <HeaderMenu />
        <div className="container px-2 relative z-10">
          <div
            className="mx-auto bg-white/95 border-solid border-[#36A638] border-[3px] rounded-3xl shadow shadow-primary p-2 md:pb-8 md:pt-4 md:px-10
                w-full"
          >
            <div
              className="rule-fix-content"
              dangerouslySetInnerHTML={{
                __html: dataSettings?.find((item) => item.key === SETTING_KEYS.RULE)?.content
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RuleFixPage;
